import dayjs from 'dayjs'
import type { ResAllType } from '../../Types/Api/All'
import type {
  FormClientRecaptcha,
  FormDataType,
  FormExternalUrl,
  SaveFormReq,
} from '../../Types/Api/Form'
import type { OKRes } from '../../Types/Api/Ok'
import { api } from './API'
import { isResErrorType, requireAuth } from './Auth'

export const searchForm = async (page: number, per_page?: number) => {
  const res = await requireAuth<ResAllType<FormDataType>>(
    api.get(`forms`, { queryType: 'search', page, per_page }),
  )

  if (!res.ok || !res.data || isResErrorType(res.data)) {
    return res
  }

  return {
    ...res,
    data: {
      ...res.data,
      data: res.data.data.map((d) => ({
        ...d,
        created_at: dayjs(d.created_at),
        updated_at: d.updated_at ? dayjs(d.updated_at) : null,
      })),
    },
  }
}

export const getAllForm = async () => {
  const res = await requireAuth(api.get('forms'))

  if (!res.ok) {
    return res
  }

  return res.data
}

export const duplicateForm = async (id: number) => {
  return await requireAuth<FormDataType>(api.post(`forms/${id}/duplicate`))
}

export const createForm = (values: SaveFormReq) => {
  return requireAuth<FormDataType>(api.post('forms', values))
}

export const updateForm = (values: SaveFormReq) => {
  return requireAuth<FormDataType>(api.patch(`forms/${values.id}`, values))
}

export const findForm = (id: number) => {
  return requireAuth<FormDataType>(api.get(`forms/${id}`))
}

export const deleteFormUser = (id: number) => {
  return requireAuth<any>(api.delete(`forms/user/${id}`))
}

export const deleteForm = (id: number) => {
  return requireAuth<OKRes>(api.delete(`forms/${id}`))
}

export const searchExternalUrls = (id: number) => {
  return requireAuth<{ id: number; form_id: number; urls: string[] }>(
    api.get(`forms/${id}/external_urls`),
  )
}

export const updateExternalUrls = (values: FormExternalUrl) => {
  return requireAuth<OKRes>(
    api.patch(`forms/${values.form_id}/external_urls`, values),
  )
}

export const searchClientRecaptcha = () => {
  return requireAuth(api.get('form_client_recaptcha'))
}

export const storeClientRecaptcha = (values: FormClientRecaptcha) => {
  return requireAuth<FormClientRecaptcha>(
    api.post('form_client_recaptcha', values),
  )
}
